"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-shopping_cart text-3xl relative" }, null, -1);
const _hoisted_3 = {
    key: 0,
    class: "bg-black text-white p-1 absolute top-[4px] right-[-10px] rounded"
};
const _hoisted_4 = { class: "py-2 text-white relative" };
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-shopping_cart text-3xl relative" }, null, -1);
const _hoisted_6 = {
    key: 0,
    class: "bg-black text-white p-1 absolute top-[4px] right-[-10px] rounded"
};
const _hoisted_7 = {
    key: 0,
    class: "bg-white"
};
const _hoisted_8 = ["onClick"];
const DropdownItem_vue_1 = __importDefault(require("../Navigation/DropdownItem.vue"));
const DropdownMenu_vue_1 = __importDefault(require("../Navigation/DropdownMenu.vue"));
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../Modal.vue"));
const CartModal_vue_1 = __importDefault(require("./CartModal.vue"));
const NavMenuItem_vue_1 = __importDefault(require("../Navigation/NavMenuItem.vue"));
const i18n_1 = require("../../common/i18n");
const cartsStore_1 = require("../../stores/carts/cartsStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CartsMobile',
    props: {
        disabled: {
            type: Boolean,
            default: true
        },
        id: {
            type: String,
            default: () => { var _a; return `carts-mobile-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    setup(__props) {
        const props = __props;
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const router = (0, vue_router_1.useRouter)();
        const activeCartModalVisible = (0, vue_3.computed)(() => cartsStore.activeCartModalVisible);
        const carts = (0, vue_3.computed)(() => cartsStore.carts);
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const activeCartSize = (0, vue_3.computed)(() => { var _a; return (_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.getSize(); });
        const closeActiveCartModal = () => {
            cartsStore.closeActiveCartModal();
        };
        const showActiveCartModal = () => {
            cartsStore.showActiveCartModal(router);
        };
        const selectCart = (cartId) => {
            cartsStore.changeActiveCartId(cartId);
            cartsStore.showActiveCartModal(router);
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", { id: __props.id }, [
                ((0, vue_2.unref)(activeCart) !== undefined && (0, vue_2.unref)(carts).length === 1)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(NavMenuItem_vue_1.default, {
                        key: 0,
                        class: "relative"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("button", {
                                class: "py-2 text-white relative",
                                onClick: _cache[0] || (_cache[0] = ($event) => (showActiveCartModal()))
                            }, [
                                _hoisted_2,
                                ((0, vue_2.unref)(activeCartSize) !== undefined &&
                                    (0, vue_2.unref)(activeCartSize) !== null &&
                                    (0, vue_2.unref)(activeCartSize) > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(activeCartSize)), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]),
                        _: 1
                    }))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(activeCartSize) !== undefined &&
                    (0, vue_2.unref)(activeCart) !== null &&
                    (0, vue_2.unref)(activeCart) !== undefined &&
                    (0, vue_2.unref)(carts).length > 1)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownMenu_vue_1.default, {
                        key: 1,
                        clickable: "",
                        hideCaret: "",
                        right: "",
                        mobileFullWidth: ""
                    }, {
                        buttonText: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("button", _hoisted_4, [
                                _hoisted_5,
                                ((0, vue_2.unref)(activeCartSize) > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(activeCartSize)), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]),
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(DropdownItem_vue_1.default, null, {
                                default: (0, vue_2.withCtx)(() => [
                                    ((0, vue_2.unref)(carts).length > 1)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(carts), (cart, index) => {
                                                var _a;
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                    key: cart.id,
                                                    onClick: ($event) => (selectCart(cart.id)),
                                                    class: (0, vue_2.normalizeClass)([
                                                        ((_a = (0, vue_2.unref)(activeCart)) === null || _a === void 0 ? void 0 : _a.id) === cart.id ? 'bg-red text-white' : '',
                                                        "font-normal p-2 border-b-1 border-gray normal-case text-center hover:bg-gray hover:text-black last:border-b-0 cursor-pointer"
                                                    ])
                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_item", "{index}. cart - number of products: {cartSize}", "carts", {
                                                    index: index + 1,
                                                    cartSize: cart.getSize(),
                                                })), 11, _hoisted_8));
                                            }), 128))
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(activeCart) && __props.disabled)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                        key: 2,
                        isOpen: (0, vue_2.unref)(activeCartModalVisible),
                        title: (0, vue_2.unref)(i18n_1.trans)('cart_modal_title', 'Cart', 'carts'),
                        widthClasses: "w-full max-w-full max-w-screen-lg",
                        backgroundColorClass: "bg-[#f2f2f2]",
                        onClose: _cache[1] || (_cache[1] = ($event) => (closeActiveCartModal()))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(CartModal_vue_1.default, { id: "carts-mobile-cart-modal" })
                        ]),
                        _: 1
                    }, 8, ["isOpen", "title"]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 8, _hoisted_1));
        };
    }
});
